<template>
  <header class="fixed z-50 bg-emma py-4 px-6 w-full md:px-24">
    <div class="flex flex-row justify-between items-center">
      <!-- Logo -->
      <div class="flex flex-col">
        <a href="#home" @click.prevent="scrollToSection('home')"><h1 class="text-black">Portfolio Emma Nabyt</h1></a>
        <hr class="border-cv border-2 rounded-full">
      </div>

      <!-- Bouton Hamburger pour mobile -->
      <button @click="toggleMenu" class="md:hidden text-black text-3xl focus:outline-none">
        ☰
      </button>

      <!-- Navigation Desktop -->
      <nav class="hidden md:flex justify-end text-black">
        <router-link to="/home" >
          <a href="#home" class="mr-2 md:mr-5 transition duration-300 ease-in-out hover:text-gray-500">Accueil</a>
        </router-link>        
        <a href="#about" @click.prevent="scrollToSection('about')" class="mr-2 md:mr-5 transition duration-300 ease-in-out hover:text-gray-500">A propos</a>
        <a href="#projet" @click.prevent="scrollToSection('projet')" class="mr-2 md:mr-5 transition duration-300 ease-in-out hover:text-gray-500">Projets</a>
        <a href="#contact" @click.prevent="scrollToSection('contact')" class="mr-2 md:mr-5 transition duration-300 ease-in-out hover:text-gray-500">Contact</a>

       
      </nav>
    </div>

    <!-- Menu Mobile -->
    <div v-if="menuOpen" class="md:hidden absolute top-full left-0 w-full bg-emma shadow-lg flex flex-col items-center py-4 space-y-4 transition-transform duration-300">
      <a href="#home" @click.prevent="scrollToSection('home')" class="text-black text-lg hover:text-gray-500">Accueil</a>
      <a href="#about" @click.prevent="scrollToSection('about')" class="text-black text-lg hover:text-gray-500">A propos</a>
      <a href="#projet" @click.prevent="scrollToSection('projet')" class="text-black text-lg hover:text-gray-500">Projets</a>
      <a href="#contact" @click.prevent="scrollToSection('contact')" class="text-black text-lg hover:text-gray-500">Contact</a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      menuOpen: false
    };
  },
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      this.menuOpen = false; // Ferme le menu après le clic
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  }
};
</script>

<style scoped>
/* Ajoute des animations pour le menu mobile */
</style>
